import { BaseAPI } from "./base-api";
/**
 * Helper class que tiene como objetivo
 * agrupar las invocaciones a la api de paquetes.
 */
class ProyectoAPI extends BaseAPI {
  resource = "/proyectos/";
    /**
   * Se encarga de recuperar los del recurso por su id
   * @param {number}id
   */
  eventos(id) {
    return this.api.get(this.resource + id + "/eventos");
  }

}

export default new ProyectoAPI();
